import { useCallback, useState } from "react";
import { JoinScreen } from "./components/screens/JoinScreen";
import { LeaveScreen } from "./components/screens/LeaveScreen";
import { JitsiMeetingView } from "./components/JitsiMeetingView";
import { checkMeetingExists } from "./api/meetingLinks";
import { getRoomFromUrl } from "./utils/meeting";

function App() {
  const [participantName, setParticipantName] = useState("");
  const [roomName, setRoomName] = useState("");
  const [meetingKey, setMeetingKey] = useState(0);
  const [view, setView] = useState("join");
  const [role, setRole] = useState("participant");

  const handleStartMeeting = useCallback((room, nextRole) => {
    setRoomName(room);
    setRole(nextRole === "host" ? "host" : "participant");
    setView("meeting");
  }, []);

  const handleLeave = useCallback(() => {
    setView("leave");
  }, []);

  const handleRejoin = useCallback(async () => {
    const room = roomName || getRoomFromUrl();
    if (!room) {
      setView("join");
      return;
    }
    try {
      const { exists } = await checkMeetingExists(room);
      if (!exists) {
        setView("join");
        return;
      }
      setRoomName(room);
      setMeetingKey((key) => key + 1);
      setView("meeting");
    } catch {
      setView("join");
    }
  }, [roomName]);

  if (view === "meeting" && roomName) {
    return (
      <JitsiMeetingView
        key={meetingKey}
        roomName={roomName}
        participantName={participantName}
        asHost={role === "host"}
        onLeave={handleLeave}
        onRejoin={handleRejoin}
      />
    );
  }

  if (view === "leave") {
    return <LeaveScreen onRejoin={handleRejoin} />;
  }

  return (
    <JoinScreen
      participantName={participantName}
      setParticipantName={setParticipantName}
      onStartMeeting={handleStartMeeting}
    />
  );
}

export default App;
